






















import { Component, Vue } from "vue-property-decorator";

@Component
export default class Confirm extends Vue {
  dialog = false;
  title = "";
  text = "";
  resolve?: (value: boolean | PromiseLike<boolean>) => void;

  public open(title: string, text: string) {
    this.title = title;
    this.text = text;
    this.dialog = true;
    return new Promise<boolean>((resolve) => {
      this.resolve = resolve;
    });
  }

  close(res: boolean) {
    this.dialog = false;
    if (this.resolve) {
      return this.resolve(res);
    }
  }
}
